import { render, staticRenderFns } from "./become-member-alert.vue?vue&type=template&id=61f425c7&scoped=true"
import script from "./become-member-alert.vue?vue&type=script&lang=js"
export * from "./become-member-alert.vue?vue&type=script&lang=js"
import style0 from "./become-member-alert.vue?vue&type=style&index=0&id=61f425c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f425c7",
  null
  
)

export default component.exports